<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <app-back-button></app-back-button>
    </div>
  </div>
</ng-template>

@if (inquiry) {
  <app-tab-switcher [config]="tabConfig"></app-tab-switcher>
  <router-outlet></router-outlet>
}
